import React from 'react';

// 2-state status for charity donation ledger rows — unlike commission payouts
// (formatPayoutStatus.js) there's no "undelivered" state, since a donation
// entry only ever exists for an already-earned order. Same color language as
// the commission-payout pending/paid pills for visual consistency.
const CHARITY_DONATION_STATUSES = {
  pending: { label: 'Na čekanju', bg: '#FEF0C7', text: '#DC6803' },
  paid: { label: 'Realizovano', bg: '#ECFDF3', text: '#027A48' },
};

export const formatCharityDonationStatusAsPill = (status) => {
  const { label, bg, text } =
    CHARITY_DONATION_STATUSES[status] || CHARITY_DONATION_STATUSES.pending;
  return (
    <span
      style={{
        padding: '4px 12px',
        borderRadius: '16px',
        fontSize: '14px',
        fontWeight: '500',
        display: 'inline-block',
        backgroundColor: bg,
        color: text,
      }}
    >
      {label}
    </span>
  );
};

export const charityDonationStatusLabel = (status) =>
  (CHARITY_DONATION_STATUSES[status] || CHARITY_DONATION_STATUSES.pending)
    .label;
